(function () {
	'use strict';

	function initSection(section) {
		var track = section.querySelector('.m1o2-pdp-tst__track');
		if (!track) return;
		var prev = section.querySelector('.m1o2-pdp-tst__nav--prev');
		var next = section.querySelector('.m1o2-pdp-tst__nav--next');

		function step() {
			var card = track.querySelector('.m1o2-pdp-tst__card');
			if (!card) return track.clientWidth;
			var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
			return card.getBoundingClientRect().width + gap;
		}
		if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
		if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

		/* Sort (best-effort reorder of placeholder cards) */
		var sort = section.querySelector('[data-tst-sort]');
		if (sort) {
			sort.addEventListener('change', function () {
				var cards = Array.prototype.slice.call(track.querySelectorAll('.m1o2-pdp-tst__card'));
				var mode = sort.value;
				cards.sort(function (a, b) {
					if (mode === 'rating') { return parseFloat(b.getAttribute('data-rating')) - parseFloat(a.getAttribute('data-rating')); }
					if (mode === 'newest') { return parseInt(a.getAttribute('data-order'), 10) - parseInt(b.getAttribute('data-order'), 10); }
					return parseInt(a.getAttribute('data-order'), 10) - parseInt(b.getAttribute('data-order'), 10);
				});
				cards.forEach(function (c) { track.appendChild(c); });
			});
		}
	}

	document.addEventListener('DOMContentLoaded', function () {
		Array.prototype.slice.call(document.querySelectorAll('.m1o2-pdp-tst')).forEach(initSection);
	});
})();
